// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaFacebook_root__1AS71"};